import {
  canAccessDevopsWorkspace,
  isDevopsOperator,
  isEnvironmentManager,
} from "./appRoles";
import type { ConfigurationScope } from "../types/devops";

export function canMaintainEnvironment(roles: string[] | undefined | null): boolean {
  return isEnvironmentManager(roles);
}

export function canMaintainApplication(roles: string[] | undefined | null): boolean {
  return isDevopsOperator(roles);
}

export function canMaintainRelease(roles: string[] | undefined | null): boolean {
  return isDevopsOperator(roles);
}

export function canMaintainConfiguration(
  roles: string[] | undefined | null,
  scope: ConfigurationScope,
): boolean {
  return scope === "ENVIRONMENT"
    ? isEnvironmentManager(roles)
    : isDevopsOperator(roles);
}

export function canMapEnvironmentApplications(
  roles: string[] | undefined | null,
): boolean {
  return canAccessDevopsWorkspace(roles);
}

export function parseCsvList(value: string): string[] {
  return value
    .split(/[,;\n]+/)
    .map((part) => part.trim())
    .filter(Boolean);
}
